import { getProductColumns } from "../constants/columns";
import useProductsTable from "../hooks/useProductsTable";
import { useGetWindowHeight } from "@neonumy/neonumy-ui";
import { TableFilter } from "@neonumy/ant-design";
import useAuthStore from "views/hooks/useAuthStore";
import { Content } from "antd/es/layout/layout";
import { useTranslation } from "react-i18next";
import CreateProduct from "./CreateProduct";
import { Typography } from "antd";
import { useMemo } from "react";

export default function ProductsDataTable(): React.ReactElement {
  const windowHeight = useGetWindowHeight();
  const { t } = useTranslation();

  const userData = useAuthStore(state => state.userData);
  const invoiceLanguage = userData?.language?.toLowerCase();

  const {
    dataSource,
    loading,
    totalCount,
    categoryOptions,
    currentPage,
    pageSize,
    handlePagination,
    filters,
    setFilters,
    handleSearchFilters,
    handleResetFilter,
    refetch,
  } = useProductsTable();

  const columns = useMemo(
    () => getProductColumns({ t, categoryOptions, refetch, invoiceLanguage }),
    [t, categoryOptions, refetch, invoiceLanguage],
  );

  return (
    <Content className="layout-card-content">
      <Typography.Title className="documents-title" level={4}>
        {t("Products")}
      </Typography.Title>
      <TableFilter
        className="antd-newrai-table"
        scroll={{ y: windowHeight - 350 }}
        dataSource={dataSource}
        loading={loading}
        columns={columns}
        defaultSearchFilter={handleSearchFilters}
        defaultResetFilter={handleResetFilter}
        defaultFiltersObject={filters}
        defaultFilterSet={setFilters}
        pagination={{
          onChange: handlePagination,
          showSizeChanger: true,
          current: currentPage,
          pageSize: pageSize,
          total: totalCount,
          showTotal: total => t("Total table items", { count: total }),
        }}
        debounced={true}
      />
      <CreateProduct loading={loading} refetch={refetch} />
    </Content>
  );
}
